import { render } from "./modalComponent.vue?vue&type=template&id=96137bde&scoped=true"
import script from "./modalComponent.vue?vue&type=script&lang=js"
export * from "./modalComponent.vue?vue&type=script&lang=js"

import "./modalComponent.vue?vue&type=style&index=0&id=96137bde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96137bde"]])

export default __exports__